import { memo } from 'react';
import type { ScrollToBottom } from 'use-stick-to-bottom';
import { Plan } from './message-parts/Plan';
import { ToolCall } from './message-parts/ToolCall';
import { ToolCallGroup } from './message-parts/ToolCallGroup';
import { Text } from '~/components/chat/assistant-message/message-parts/Text';
import type { ProcessedPart, TodoGroupsData } from '~/components/chat/assistant-message/types';
import { isTextPart, isTodoWritePart, isToolInvocationPart, isToolInvocationGroupPart } from '~/lib/ai';

export interface AssistantMessagePartProps {
  part: ProcessedPart;
  isPending: boolean;
  scrollToBottom?: ScrollToBottom;
  todoGroupsData?: TodoGroupsData;
}

export const AssistantMessagePart = memo((props: AssistantMessagePartProps) => {
  const { part, scrollToBottom, todoGroupsData } = props;

  if (isTextPart(part)) {
    return <Text key={part.id} part={part} scrollToBottom={scrollToBottom} />;
  }

  if (isToolInvocationPart(part)) {
    if (isTodoWritePart(part) && todoGroupsData) {
      return <Plan key={part.toolInvocation.toolCallId} part={part} todoGroupsData={todoGroupsData} />;
    }

    return (
      <ToolCall key={part.toolInvocation.toolCallId} isPending={props.isPending} toolInvocation={part.toolInvocation} />
    );
  }

  if (isToolInvocationGroupPart(part)) {
    return <ToolCallGroup part={part} isPending={props.isPending} />;
  }

  return null;
});

AssistantMessagePart.displayName = 'AssistantMessagePart';
